<!-- 答辩成绩 -->
<template>
  <svg v-if="modelValue == 0" class="notStarted" viewBox="0 0 35.2 38.09">
    <title>答辩成绩</title>
    <g id="图层_2" data-name="图层 2">
      <g id="图层_1-2" data-name="图层 1">
        <ellipse class="cls-1" cx="17.6" cy="29.49" rx="17.6" ry="8.6" />
        <ellipse class="cls-2" cx="17.6" cy="29.49" rx="13.61" ry="6.79" />
        <path
          class="cls-3"
          d="M30.52,6.09V4.78A3.78,3.78,0,0,0,26.74,1H9A3.78,3.78,0,0,0,5.25,4.78V24.72A3.78,3.78,0,0,0,9,28.5H26.74a3.78,3.78,0,0,0,3.78-3.78V13"
        />
        <line class="cls-3" x1="10.97" y1="16.28" x2="24.9" y2="16.28" />
        <line class="cls-3" x1="10.97" y1="21.98" x2="24.9" y2="21.98" />
        <line class="cls-3" x1="20.95" y1="7.11" x2="24.76" y2="7.11" />
        <line class="cls-3" x1="22.85" y1="5.26" x2="22.85" y2="8.96" />
        <path
          class="cls-3"
          d="M10.53,11.85l1.18-2.51,1.78-3.79a.46.46,0,0,1,.83,0l3.24,6.33"
        />
        <line class="cls-3" x1="12.13" y1="9.16" x2="15.94" y2="9.16" />
        <circle class="cls-4" cx="30.6" cy="9.57" r="1.18" />
        <line class="cls-3" x1="20.95" y1="12.02" x2="24.76" y2="12.02" />
      </g>
    </g>
  </svg>
  <svg v-else-if="modelValue == 1" class="inProgress" viewBox="0 0 35.2 38.09">
    <title>答辩成绩</title>
    <g id="图层_2" data-name="图层 2">
      <g id="图层_1-2" data-name="图层 1">
        <ellipse class="cls-1" cx="17.6" cy="29.49" rx="17.6" ry="8.6" />
        <ellipse class="cls-2" cx="17.6" cy="29.49" rx="13.61" ry="6.79" />
        <path
          class="cls-3"
          d="M30.52,6.09V4.78A3.78,3.78,0,0,0,26.74,1H9A3.78,3.78,0,0,0,5.25,4.78V24.72A3.78,3.78,0,0,0,9,28.5H26.74a3.78,3.78,0,0,0,3.78-3.78V13"
        />
        <line class="cls-3" x1="10.97" y1="16.28" x2="24.9" y2="16.28" />
        <line class="cls-3" x1="10.97" y1="21.98" x2="24.9" y2="21.98" />
        <line class="cls-3" x1="20.95" y1="7.11" x2="24.76" y2="7.11" />
        <line class="cls-3" x1="22.85" y1="5.26" x2="22.85" y2="8.96" />
        <path
          class="cls-3"
          d="M10.53,11.85l1.18-2.51,1.78-3.79a.46.46,0,0,1,.83,0l3.24,6.33"
        />
        <line class="cls-3" x1="12.13" y1="9.16" x2="15.94" y2="9.16" />
        <circle class="cls-4" cx="30.6" cy="9.57" r="1.18" />
        <line class="cls-3" x1="20.95" y1="12.02" x2="24.76" y2="12.02" />
      </g>
    </g>
  </svg>
  <svg v-else viewBox="0 0 35.13 37.52">
    <title>答辩成绩</title>
    <g id="图层_2" data-name="图层 2">
      <g id="图层_1-2" data-name="图层 1">
        <ellipse class="cls-1" cx="17.56" cy="28.94" rx="17.56" ry="8.58" />
        <ellipse class="cls-2" cx="17.56" cy="28.94" rx="13.59" ry="6.78" />
        <path
          class="cls-3"
          d="M30.27,5.93V4.62A3.78,3.78,0,0,0,26.49.84H8.78A3.78,3.78,0,0,0,5,4.62V24.56a3.78,3.78,0,0,0,3.78,3.78H26.49a3.78,3.78,0,0,0,3.78-3.78V12.84"
        />
        <line class="cls-3" x1="10.72" y1="16.12" x2="24.65" y2="16.12" />
        <line class="cls-3" x1="10.72" y1="21.82" x2="24.65" y2="21.82" />
        <line class="cls-4" x1="20.7" y1="6.96" x2="24.51" y2="6.96" />
        <line class="cls-4" x1="22.6" y1="5.11" x2="22.6" y2="8.81" />
        <path
          class="cls-3"
          d="M10.28,11.69l1.19-2.51L13.25,5.4a.45.45,0,0,1,.82,0l3.24,6.34"
        />
        <line class="cls-5" x1="11.88" y1="9" x2="15.69" y2="9" />
        <circle class="cls-6" cx="30.36" cy="9.4" r="1.1" />
        <line class="cls-4" x1="20.7" y1="11.87" x2="24.51" y2="11.87" />
      </g>
    </g>
  </svg>
</template>
<script lang="ts" setup>
  withDefaults(
    defineProps<{
      /** 任务执行状态 */
      modelValue: number;
    }>(),
    // 默认值
    { modelValue: 0 }
  );
</script>
<style lang="scss" scoped>
  // 未开始
  .notStarted {
    .cls-1 {
      fill: #f0f7f7;
    }
    .cls-2 {
      fill: #d7e2e2;
    }
    .cls-3 {
      fill: none;
      stroke: #9a9b9b;
      stroke-linecap: round;
      stroke-miterlimit: 10;
      stroke-width: 2px;
    }
    .cls-4 {
      fill: #9a9b9b;
    }
  }
  // 进行中
  .inProgress {
    .cls-1 {
      fill: #f4e4d4;
    }
    .cls-2 {
      fill: #efd0a3;
    }
    .cls-3 {
      fill: none;
      stroke: #ed9c24;
      stroke-linecap: round;
      stroke-miterlimit: 10;
      stroke-width: 2px;
    }
    .cls-4 {
      fill: #ed9c24;
    }
  }
  // 已完成
  .completed {
    .cls-1 {
      fill: #d5ebe9;
    }
    .cls-2 {
      fill: #b8ded9;
    }
    .cls-3,
    .cls-4,
    .cls-5 {
      fill: none;
      stroke: #27aa8e;
      stroke-linecap: round;
      stroke-miterlimit: 10;
    }
    .cls-3 {
      stroke-width: 1.69px;
    }
    .cls-4 {
      stroke-width: 1.46px;
    }
    .cls-5 {
      stroke-width: 1.35px;
    }
    .cls-6 {
      fill: #27aa8e;
    }
  }
</style>
